var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
import { CustomElementUtils } from '../../utils-customelement';
//namespace Pacem.Components {
export class PacemTransferProxyElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._dom = [];
        this._children = [];
    }
    get dom() {
        return this._children;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.moveContent(this.proxy);
    }
    moveContent(to) {
        if (!Utils.isNull(to)) {
            if (Utils.isNullOrEmpty(this._dom)) {
                this._dom = Utils.moveItems(this.childNodes, to);
                this._children = this._dom.filter(e => e instanceof Element);
            }
            else {
                Utils.moveItems(this._children, to);
            }
        }
    }
    disconnectedCallback() {
        for (let item of (this._dom || []).splice(0)) {
            item.remove();
        }
        super.disconnectedCallback();
    }
}
/** Moves its content to the document body and eventually removes it when disconnected. */
let PacemBodyProxyElement = class PacemBodyProxyElement extends PacemTransferProxyElement {
    get proxy() {
        return document.body;
    }
};
PacemBodyProxyElement = __decorate([
    CustomElement({
        tagName: P + '-body-proxy'
    })
], PacemBodyProxyElement);
export { PacemBodyProxyElement };
/** Moves its content to the closest shell and eventually removes it when disconnected. */
let PacemShellProxyElement = class PacemShellProxyElement extends PacemTransferProxyElement {
    get proxy() {
        return CustomElementUtils.findAncestorShell(this);
    }
};
PacemShellProxyElement = __decorate([
    CustomElement({
        tagName: P + '-shell-proxy'
    })
], PacemShellProxyElement);
export { PacemShellProxyElement };
/** Moves its content to the provided target element. */
let PacemElementProxyElement = class PacemElementProxyElement extends PacemTransferProxyElement {
    get proxy() {
        return this.target;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'target' && !first) {
            this.moveContent(this.proxy);
        }
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Element })
], PacemElementProxyElement.prototype, "target", void 0);
PacemElementProxyElement = __decorate([
    CustomElement({
        tagName: P + '-element-proxy'
    })
], PacemElementProxyElement);
export { PacemElementProxyElement };
//}
